import React, { useState,useEffect, useCallback } from "react";
import { useAuth } from "./Header/AuthContext";
import Header from "./Header/Header";
import Footer from "./Header/Footer";
import Config from "./Header/Config";
import Navbar from "./Header/Navbar";
import axios from "axios";
function Dashboard () {
   const username = localStorage.getItem("username");

   //...............................................................
   const [openingStock, setOpeningStock] = useState(0);
   const [closingStock, setClosingStock] = useState(0);


  //  .........................sell Details......................
   const [todaySelleCount, settodaySelleCount] = useState(0);
   const [sellTotalamount, setsellTotalamount] = useState(0);
   const [yesterdaySell, setyesterdaySell] = useState(0);
   const [todaysAccount, setTodaysAccount] = useState(0);
   const [todaysCash, setTodaysCash] = useState(0);
   const [sellList, setsellList] = useState([]);

  //  .........................Buyback Details......................
  const [todayBuyBackCount, settodayBuyBackCount] = useState(0);
  const [yesterdayBuyCount, setyesterdayBuyCount] = useState(0);




  //  .....................Purchase Details.....................
   const [purchaseCount, setpurchaseCount] = useState([]);
   const [purchaseList, setPurchaseList] = useState([]);



   
 
   const apiUrl = Config.apiUrl;
   const fetchData = useCallback(async () => {
    try {
  //  .........................sell Details......................

      const sellresponse = await axios.get(`${apiUrl}/getSalesCount`);
      console.log(sellresponse)
      setsellList(sellresponse.data.data || [])
      settodaySelleCount(sellresponse.data.todaySelleCount || 0)
      setsellTotalamount(sellresponse.data.salesTotal || 0)
      setyesterdaySell(sellresponse.data.yesterdaySell || 0)
      setTodaysAccount(sellresponse.data.todaysAccount || 0)
      setTodaysCash(sellresponse.data.todaysCash || 0)

      // Buyback Details from getSalesCount response
      settodayBuyBackCount(sellresponse.data.todaybuybackCount || 0)
      setyesterdayBuyCount(sellresponse.data.yesterdaybuybackCount || 0)

      // Purchase Details from getSalesCount response
      setpurchaseCount(sellresponse.data.todayPurchaseCount || 0)
      setPurchaseList(sellresponse.data.todayspurchaseItems || [])

      // Total Stock from getSalesCount response
      setOpeningStock(sellresponse.data.totalStock || 0);

      // Closing Stock from getSalesCount response
      setClosingStock(sellresponse.data.closingStock || 0);

    } catch (error) {
      console.error(error);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  
return (

<>
<>
  <div className="layout-wrapper layout-content-navbar">
    <div className="layout-container">
    
      <Header/>
    
      <div className="layout-page">
        {/* <Navbar/> */}
        <div className="content-wrapper">
          {/* Content */}
          <div className="container-xxl flex-grow-1 container-p-y">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-6 mb-4 order-0">
                <div className="card">
                  <div className="d-flex align-items-end row">
                    <div className="col-12 col-sm-7">
                      <div className="card-body">
                        <h5 className="card-title text-primary">
                          Welcome {username}! 🎉
                        </h5>
                        <h5 className="card-title text-primary">
                          Mobile City Gadhinglaj
                        </h5>
                        
                      </div>
                    </div>
                    <div className="col-12 col-sm-5 text-center text-sm-left">
                      <div className="card-body pb-0 px-0 px-md-4">
                        <img
                          src="../assets/img/illustrations/man-with-laptop-light.png"
                          height={140}
                          alt="View Badge User"
                          data-app-dark-img="illustrations/man-with-laptop-dark.png"
                          data-app-light-img="illustrations/man-with-laptop-light.png"
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 order-1">
              <div className="card h-100">
                      <div className="card-body">
                        <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                          <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                            <div className="card-title">
                              <h5 className="text-nowrap mb-2" style={{ fontSize: "0.9rem" }}>
                                Today's Account
                              </h5>
                            </div>
                            <div className="mt-sm-auto">
                              <h3 className="mb-0" style={{ fontSize: "1.5rem" }}>{todaysAccount || 0}</h3>
                            </div>
                          </div>
                          <div id="profileReportChart" />
                        </div>
                      </div>
                    </div>
              </div>

              <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 order-1">
              <div className="card h-100">
                      <div className="card-body">
                        <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                          <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                            <div className="card-title">
                              <h5 className="text-nowrap mb-2" style={{ fontSize: "0.9rem" }}>
                                Today's Cash
                              </h5>
                            </div>
                            <div className="mt-sm-auto">
                              <h3 className="mb-0" style={{ fontSize: "1.5rem" }}>{todaysCash || 0}</h3>
                            </div>
                          </div>
                          <div id="profileReportChart" />
                        </div>
                      </div>
                    </div>
              </div>
              {/* Total Revenue */}
               
            </div>
            <div className="row">
              {/* Summary Cards: Yesterday's Sell, Closing Stock, Total Stock, Yesterday's Buyback */}
              <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 order-0 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                      <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                        <div className="card-title">
                          <h5 className="text-nowrap mb-2" style={{ fontSize: "0.9rem" }}>Yesterday's Sell</h5>
                        </div>
                        <div className="mt-sm-auto">
                          <h3 className="mb-0" style={{ fontSize: "1.5rem" }}>{yesterdaySell}</h3>
                        </div>
                      </div>
                      <div id="profileReportChart" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 order-0 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                      <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                        <div className="card-title">
                          <h5 className="text-nowrap mb-2" style={{ fontSize: "0.9rem" }}>Closing Stock</h5>
                        </div>
                        <div className="mt-sm-auto">
                          <h3 className="mb-0" style={{ fontSize: "1.5rem" }}>{closingStock}</h3>
                        </div>
                      </div>
                      <div id="profileReportChart" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 order-0 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                      <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                        <div className="card-title">
                          <h5 className="text-nowrap mb-2" style={{ fontSize: "0.9rem" }}>Total Stock</h5>
                        </div>
                        <div className="mt-sm-auto">
                          <h3 className="mb-0" style={{ fontSize: "1.5rem" }}>{openingStock}</h3>
                        </div>
                      </div>
                      <div id="profileReportChart" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 order-0 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                      <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                        <div className="card-title">
                          <h5 className="text-nowrap mb-2" style={{ fontSize: "0.9rem" }}>Yesterday's Buyback</h5>
                        </div>
                        <div className="mt-sm-auto">
                          <h3 className="mb-0" style={{ fontSize: "1.5rem" }}>{yesterdayBuyCount}</h3>
                        </div>
                      </div>
                      <div id="profileReportChart" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {/* Order Statistics */}
              <div className="col-12 col-md-12 col-lg-8 col-xl-8 order-0 mb-2">
                <div className="card" style={{height:"280px"}}>
                  <div className="card-header d-flex align-items-center justify-content-between pb-0 flex-wrap" style={{ padding: "0.75rem 1rem" }}>
                    <div className="card-title mb-0">
                      <h5 className="m-0 me-2" style={{color:"blue", fontSize: "1rem"}}>Today Sell & Buyback Mobile</h5>
                    
                    </div>
                    <div className="dropdown">
                      <button
                        className="btn p-0"
                        type="button"
                        id="orederStatistics"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i className="bx bx-dots-vertical-rounded" />
                      </button>
                     
                    </div>
                  </div>
                  <div className="card-body" style={{ padding: "0.75rem 1rem" }}>
                    <div className="d-flex justify-content-between align-items-center mb-1" style={{ display: "none" }}>
                      <div className="d-flex flex-column align-items-center gap-1">
                        {/* <h2 className="mb-2">8,258</h2>
                        <span>Total Orders</span> */}
                      </div>
                      <div id="orderStatisticsChart" />
                    </div>
                    <div className="table-responsive" style={{ maxHeight: "220px", overflowY: "auto" }}>
                      <table className="table mb-0" style={{ marginBottom: 0 }}>
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                  backgroundColor: "#f5f5f5",
                                }}
                              >
                                
                              </thead>
                              <tbody>
                              {Array.isArray(sellList) && sellList.length>0 ? (
                  sellList.map((row, index) => (
                                      <tr key={index} style={{border:"none"}}>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{index + 1}</td>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{row.model_name}</td>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{row.color}</td>
                                        <td style={{border:"none", color:"red", fontSize: "0.875rem", padding: "0.5rem"}}>{row.buy_model}</td>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{row.buy_color}</td>
                                        
                                        
                                      </tr>
                                    ))
                                    ) : (
                                      <tr>
                                        <td colSpan="6" style={{ textAlign: "center", padding: "1rem", color: "#999" }}>No data available</td>
                                      </tr>
                                    )}
                              </tbody>
                            </table>
                    </div>
                  </div>
                </div>
              {/* Today's Purchase List */}
                <div className="card" style={{height:"280px", marginTop:"10px"}}>
                  <div className="card-header d-flex align-items-center justify-content-between pb-0 flex-wrap" style={{ padding: "0.75rem 1rem" }}>
                    <div className="card-title mb-0">
                      <h5 className="m-0 me-2" style={{color:"blue", fontSize: "1rem"}}>Today's Purchase</h5>
                    
                    </div>
                    <div className="dropdown">
                      <button
                        className="btn p-0"
                        type="button"
                        id="purchaseStatistics"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i className="bx bx-dots-vertical-rounded" />
                      </button>
                     
                    </div>
                  </div>
                  <div className="card-body" style={{ padding: "0.75rem 1rem" }}>
                    <div className="d-flex justify-content-between align-items-center mb-1" style={{ display: "none" }}>
                      <div className="d-flex flex-column align-items-center gap-1">
                        {/* <h2 className="mb-2">8,258</h2>
                        <span>Total Orders</span> */}
                      </div>
                      <div id="purchaseStatisticsChart" />
                    </div>
                    <div className="table-responsive" style={{ maxHeight: "220px", overflowY: "auto" }}>
                      <table className="table mb-0" style={{ marginBottom: 0 }}>
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                  backgroundColor: "#f5f5f5",
                                }}
                              >
                                
                              </thead>
                              <tbody>
                              {Array.isArray(purchaseList) && purchaseList.length>0 ? (
                  purchaseList.map((row, index) => (
                                      <tr key={index} style={{border:"none"}}>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{index + 1}</td>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{row.model_name}</td>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{row.color}</td>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{row.imei}</td>
                                        <td style={{border:"none", fontSize: "0.875rem", padding: "0.5rem"}}>{row.purchase_price}</td>
                                        
                                        
                                      </tr>
                                    ))
                                    ) : (
                                      <tr>
                                        <td colSpan="6" style={{ textAlign: "center", padding: "1rem", color: "#999" }}>No data available</td>
                                      </tr>
                                    )}
                              </tbody>
                            </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-4 order-1">
                <div className="row">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-12 mb-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="card-title d-flex align-items-start justify-content-between">
                          <div className="avatar flex-shrink-0">
                            <img
                              src="../assets/img/icons/unicons/chart-success.png"
                              alt="chart success"
                              className="rounded"
                              style={{ width: "40px", height: "40px" }}
                            />
                          </div>
                          <div className="dropdown">
                            <button
                              className="btn p-0"
                              type="button"
                              id="cardOpt3"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="bx bx-dots-vertical-rounded" />
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu-end"
                              aria-labelledby="cardOpt3"
                            >
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);"
                              >
                                View More
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);"
                              >
                                Delete
                              </a>
                            </div>
                          </div>
                        </div>
                        <span className="fw-semibold d-block mb-1" style={{ fontSize: "0.875rem" }}>Sell Count</span>
                        <h3 className="card-title mb-2" style={{ fontSize: "1.5rem" }}>{todaySelleCount}</h3>
                        
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-lg-12 mb-4">
                    <div className="card h-100">
                      <div className="card-body">
                        <div className="card-title d-flex align-items-start justify-content-between">
                          <div className="avatar flex-shrink-0">
                            <img
                              src="../assets/img/icons/unicons/wallet-info.png"
                              alt="Credit Card"
                              className="rounded"
                              style={{ width: "40px", height: "40px" }}
                            />
                          </div>
                          <div className="dropdown">
                            <button
                              className="btn p-0"
                              type="button"
                              id="cardOpt6"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="bx bx-dots-vertical-rounded" />
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu-end"
                              aria-labelledby="cardOpt6"
                            >
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);"
                              >
                                View More
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);"
                              >
                                Delete
                              </a>
                            </div>
                          </div>
                        </div>
                        <span style={{ fontSize: "0.875rem" }}>Buyback Count</span>
                        <h3 className="card-title text-nowrap mb-1" style={{ fontSize: "1.5rem" }}>{todayBuyBackCount}</h3>
                       
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-12 mb-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="card-title d-flex align-items-start justify-content-between">
                          <div className="avatar flex-shrink-0">
                            <img
                              src="../assets/img/icons/unicons/chart-success.png"
                              alt="chart success"
                              className="rounded"
                              style={{ width: "40px", height: "40px" }}
                            />
                          </div>
                          <div className="dropdown">
                            <button
                              className="btn p-0"
                              type="button"
                              id="cardOpt3"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="bx bx-dots-vertical-rounded" />
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu-end"
                              aria-labelledby="cardOpt3"
                            >
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);"
                              >
                                View More
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);"
                              >
                                Delete
                              </a>
                            </div>
                          </div>
                        </div>
                        <span className="fw-semibold d-block mb-1" style={{ fontSize: "0.875rem" }}>Purchase Count</span>
                        <h3 className="card-title mb-2" style={{ fontSize: "1.5rem" }}>{purchaseCount}</h3>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
              
              {/*/ Transactions */}
            </div>
            
            
          </div>
          {/* / Content */}
          {/* Footer */}
         <Footer/>
          {/* / Footer */}
          <div className="content-backdrop fade" />
        </div>
        {/* Content wrapper */}
      </div>
      {/* / Layout page */}
    </div>
    {/* Overlay */}
    <div className="layout-overlay layout-menu-toggle" />
  </div>
  {/* / Layout wrapper */}
  
</>

</>
);
}

export default Dashboard;